export default "__VITE_ASSET__1ff11e34__"